export enum errorCodes {
  FORBIDDEN = 403,
  NOT_FOUND = 404,
}
